// src/utils/paidUnlock.js
//
// Read/grant the paid Scene Analysis unlock. Deliberately separate from the
// shared-code gate in config/access.js: a purchase should PERSIST across
// tabs and restarts (localStorage), whereas the on-set QR unlock is
// session-only. Both are soft gates — see config/pricing.js for the honest
// note on why a no-server Payment Link can't be cryptographically enforced.

import { PRICING } from "../config/pricing";

function store() {
  try {
    return PRICING.persistence === "persistent" ? window.localStorage : window.sessionStorage;
  } catch (e) {
    return null; // private mode / storage disabled
  }
}

export function isPaidUnlocked() {
  const s = store();
  if (!s) return false;
  try {
    return s.getItem(PRICING.storageKey) === "true";
  } catch (e) {
    return false;
  }
}

export function grantPaidUnlock() {
  const s = store();
  if (!s) return;
  try {
    s.setItem(PRICING.storageKey, "true");
  } catch (e) {
    // Non-fatal: the unlock still holds for this render, just won't persist.
  }
}

export function revokePaidUnlock() {
  const s = store();
  if (!s) return;
  try {
    s.removeItem(PRICING.storageKey);
  } catch (e) {}
}
